import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Media } from '@stuplay';
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'media-manager',
    templateUrl: './media-manager.component.html',
    styleUrls: ['./media-manager.component.less']
})

export class MediaManagerComponent {
    @Input() media: Media;
    @Input() size: number;
    @Input() placeholder: string;
    @Input() mini: boolean;
    @Output() updateMedia = new EventEmitter();

    constructor(
        private modalService: NgbModal,
    ) { }

    delete() {
        if (this.media) {
            this.media = null;
            this.updateMedia.emit(this.media);
        }
    }

    onUpdatedMedia(media: any) {
        if (this.media !== media) {
            this.media = media;
            this.updateMedia.emit(this.media);
        }
    }

    modalOpen(content: any) {
        if (!this.media) {
            this.modalService.open(content);
        }
    }

    modalClose(_event: any) {
        this.modalService.dismissAll();
    }
}
